export default __webpack_public_path__ + "static/media/password-bg.32121e83.svg";